<template>
  <div class="member">
    <TeamMemberAvatar
      :id="member.id"
      class="member__avatar"
    />
    <div class="member__name-section">
      <div class="member__name">
        {{ membershipStore.memberNameById[member.id] }}
      </div>
      <div
        v-if="member.email"
        class="member__email"
      >
        {{ member.email }}
      </div>
    </div>
    <div class="member__role">
      <RoleDropdown
        :disabled="true"
        name="membership-role"
        :value="member.role"
        :options="ROLE_OPTIONS"
      />
    </div>
    <!-- we render a blank div here, to preserve the exact layout Member.vue has -->
    <div class="member__menu" />
  </div>
</template>

<script lang="ts">
/**
 * Used to render a team member line item in read-only mode, matching the same
 * layout defined in `Member.vue`
 */
export default {
  name: 'ReadOnlyMember',
}
</script>

<script lang="ts" setup>
import TeamMemberAvatar from '@/modules/Teams/TeamMemberAvatar.vue'
import type { MembershipPayload } from '@/store/types'
import RoleDropdown from '@/modules/Teams/RoleDropdown.vue'

import { ROLE_OPTIONS } from '@/modules/Teams/roleData'
import { useMembershipStore } from '@/modules/Teams/useMembershipStore'

defineProps<{
  member: MembershipPayload
}>()

const membershipStore = useMembershipStore()
</script>

<style lang="scss" scoped>
@import './MemberBase.scss';
</style>
